import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class DuplicateColumnSetRequest extends BaseServiceRequest {

    constructor(duplicateColumnSetName, activeListId, srcColSetId) {
        super();
        super.addRequestUri("columnsets.pb");
        super.addRequestParameter("n", duplicateColumnSetName);
        super.addRequestParameter("l", activeListId.toString());
        super.addRequestParameter("scs", srcColSetId.toString());
    }

    getMethod() {
        return HttpMethodType.POST;
    }

    getSubSystem() {
        return SubSystemType.LIST;
    }

    getMessageName() {
        return "ColumnSetResponse";
    }
}

export default DuplicateColumnSetRequest;
